import { useEffect, useState } from "react";
import { toast } from "sonner";
import { LockKey, PaperPlaneTilt } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AdminShell } from "@/components/Layout";
import { useAccessLog } from "@/pages/AdminAccessLog";

const LABELS = { billing: "Billing & plan", branding: "Company branding" };

// Wrap a founder-only page. Non-founders see a lock + "Request access"; founder can grant from Team.
export default function FounderGate({ area, children }) {
  const [state, setState] = useState(null);
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  useAccessLog(area);
  useEffect(() => { api.get("/access/areas").then(r => setState(r.data)).catch(() => setState({ areas: {} })); }, [area]);
  if (!state) return null;
  const a = state.areas?.[area];
  if (state.is_founder || a?.allowed) return children;
  const request = async () => {
    setBusy(true);
    try { await api.post("/access/request", { area, note }); toast.success("Request sent to the founder"); setState({ ...state, areas: { ...state.areas, [area]: { ...a, pending: true } } }); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail ?? "Could not send")); } finally { setBusy(false); }
  };
  return (
    <AdminShell>
      <div className="p-6 max-w-lg mx-auto" data-testid={`founder-gate-${area}`}>
        <div className="border-2 border-slate-900 bg-white shadow-[6px_6px_0_#0f172a] p-6 space-y-3">
          <LockKey weight="fill" size={32} className="text-slate-700"/>
          <h1 className="text-xl font-black uppercase tracking-tight">{LABELS[area] || area} is founder-only</h1>
          <p className="text-sm text-slate-600">This area changes how the company is billed or presented, so it stays with the account founder. Need something changed here? Ask and it can be unlocked for you for 24 hours or permanently.</p>
          {a?.pending ? (
            <div className="border-2 border-amber-400 bg-amber-50 p-3 text-sm font-bold text-amber-900" data-testid="gate-pending">Request sent — you'll get a bell notification when it's unlocked.</div>
          ) : (
            <>
              <textarea value={note} onChange={e => setNote(e.target.value)} rows={2} placeholder="What do you need to change? (optional)" className="w-full px-3 py-2 border border-slate-300 text-sm" data-testid="gate-note"/>
              <button onClick={request} disabled={busy} className="h-11 px-5 bg-slate-900 text-white font-black uppercase text-xs tracking-widest inline-flex items-center gap-2 disabled:opacity-50" data-testid="gate-request">
                <PaperPlaneTilt weight="fill" size={14}/> Request access
              </button>
            </>
          )}
        </div>
      </div>
    </AdminShell>
  );
}
